import _extends from "@babel/runtime/helpers/extends";
import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import PageLoadingSpinner from '@jobmatchme/ui/es/components/PageLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ExportAppContainer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'legali' */'./');
});
export default (function (props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: "Truck-Jobs Impressum"
      })
    }), /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(PageLoadingSpinner, {
        fullHeight: true
      }),
      children: /*#__PURE__*/_jsx(ExportAppContainer, _extends({}, props))
    })]
  });
});